"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = exports.Notification = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const I18n_1 = require("../../i18n/I18n");
const Notification = ({ children, title, show = true, }) => {
    const { t } = I18n_1.useTranslation();
    return (jsx_runtime_1.jsxs("div", Object.assign({ hidden: !show }, { children: [jsx_runtime_1.jsx("div", { children: "string" === typeof title ? t(title) : title }, void 0),
            jsx_runtime_1.jsx("div", { children: children }, void 0)] }), void 0));
};
exports.Notification = Notification;
function useNotification(_a) {
    var { Component } = _a, props = tslib_1.__rest(_a, ["Component"]);
    const [notification, setNotification] = react_1.useState(undefined);
    if (!Component) {
        Component = exports.Notification;
    }
    return {
        notification: (jsx_runtime_1.jsx(Component, Object.assign({}, props, { onClose: () => setNotification(undefined), show: !!notification }, { children: notification }), void 0)),
        setNotification,
    };
}
exports.useNotification = useNotification;
//# sourceMappingURL=Notification.js.map